import { render, staticRenderFns } from "./LibraryDeleteModal.vue?vue&type=template&id=0cc0657e&scoped=true"
import script from "./LibraryDeleteModal.vue?vue&type=script&lang=js"
export * from "./LibraryDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./LibraryDeleteModal.vue?vue&type=style&index=0&id=0cc0657e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0657e",
  null
  
)

export default component.exports